import { version as packageVersion } from '../../package.json';
import { createAppVersionInfo } from './versioning';

export const appVersion = packageVersion;
export const appBuildNumber = __APP_BUILD_NUMBER__;
export const appDisplayVersion = `${appVersion}.${appBuildNumber}`;
export const currentAppVersion = createAppVersionInfo(appVersion, appBuildNumber);
